import { ICellRendererParams } from "ag-grid-community";
import { useDispatch } from "react-redux";

import { IgLink } from "@intelligems/ig-theme";
import { AgencySubscriptionProductLinkDto } from "@intelligems/ig-types";
import { openDrawer } from "@src/store/slices/drawers";

export const ViewUsageColumn = (
  params: ICellRendererParams<AgencySubscriptionProductLinkDto>
) => {
  const dispatch = useDispatch();
  const data = params.data;

  if (!data) {
    return null;
  }

  if (params.data?.id === "grandTotal") {
    return null;
  }
  return (
    <IgLink
      onClick={() => {
        dispatch(
          openDrawer({
            type: "meterLog",
            subscription: {
              stripeProductLinkId: data.id,
              subscriptionLinkId: data.stripeSubscriptionLinkId,
              organizationId: data.organization.id,
            },
          })
        );
      }}
    >
      View Usage
    </IgLink>
  );
};
